/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InvalidRequest = {
    /**
     * Human readable description of the error
     */
    message: string;
    /**
     * A detailed description of the error.
     */
    validation: {
        propertyLocation: InvalidRequest.propertyLocation;
        /**
         * Property that violates the validation rules (dot separated in case of nested property)
         */
        property: string | null;
        /**
         * Violated validation rule (see OpenAPI spec for explanation)
         */
        schemaRule: InvalidRequest.schemaRule;
    };
    applicationErrorId: string | null;
};
export namespace InvalidRequest {
    export enum propertyLocation {
        BODY = 'body',
        QUERY = 'query',
        HEADER = 'header',
    }
    /**
     * Violated validation rule (see OpenAPI spec for explanation)
     */
    export enum schemaRule {
        FORMAT = 'format',
        PATTERN = 'pattern',
        REQUIRED = 'required',
        NULLABLE = 'nullable',
        ENUM = 'enum',
        MIN_LENGTH = 'minLength',
        MAX_LENGTH = 'maxLength',
        MIN_ITEMS = 'minItems',
        MAX_ITEMS = 'maxItems',
        MINIMUM = 'minimum',
        MAXIMUM = 'maximum',
        MIN_PROPERTIES = 'minProperties',
        MAX_PROPERTIES = 'maxProperties',
        UNIQUE_ITEMS = 'uniqueItems',
        MULTIPLE_OF = 'multipleOf',
        ADDITIONAL_PROPERTIES = 'additionalProperties',
        NOT = 'not',
        CONTENT_TYPE = 'contentType',
        ANY_OF = 'anyOf',
        ONE_OF = 'oneOf',
    }
}

